<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @del="deldata" @imp="impx"
                    @print="print" @save="save" @execute="execute" ref="SetBtn"></buttonlist>

        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        :filter_language="['Negative_Flag','Order_status']"
                        queryData="InvissueManufactureViewInfo"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <!-- 右侧编辑内容-->
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click="gred(dataDetail.Head.Order_No)" :disabled="!btn.red">{{ $t('getapi[2107]')}}
                    </el-button>
                </div>
                <div style="width:830px;min-width:830px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px">
                                <span>{{ $t('getapi[463]') }}</span>
                            </td>
                            <td style="width:120px;min-width:120px"><el-input v-model="dataDetail.Head.Order_No" :readonly="true" class="readO"
                                                                              size="mini"></el-input></td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2177]') }}</span></td>
                            <td style="width:150px;min-width:150px">
                                <el-select class="mcolor"
                                           filterable
                                           popper-class="select-option"
                                           :disabled="disabled_issue_type_ID"
                                           v-model="dataDetail.Head.issue_type_ID"
                                           @change="SelissuetypeID"
                                           size="mini"
                                >
                                    <el-option v-for="item in ArrayIssueType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[552]') }}</span></td>
                            <td style="width:120px;min-width:120px"><el-input :value="expStatus(dataDetail.Head.Order_status)" :readonly="true" class="readO"
                                                                              size="mini"></el-input></td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[1862]') }}</span></td>
                            <td style="width:120px;min-width:120px"><el-input :value="expFinanceStatus(dataDetail.Head.Finance_Status)" :readonly="true" class="readO"
                                                                              size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1419]') }}</span></td>
                            <td><el-input v-model="dataDetail.Head.keep_account_person" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[1420]') }}</span></td>
                            <td><el-date-picker
                                    v-model="dataDetail.Head.keep_account_time"
                                    popper-class="select-option"
                                    type="date"
                                    style="width:100%"
                                    value-format="yyyy-MM-dd"
                                    :placeholder="$t('getapi[6428]')"
                                    size="mini"
                                    :readonly="dataDetail.Head.Order_status == 1 ? true : false"
                                    :class="{'readO':dataDetail.Head.Order_status == 1}"
                            ></el-date-picker></td>
                            <td><span>{{ $t('getapi[2204]') }}</span></td>
                            <td><el-input v-model="dataDetail.Head.issue_person" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[1857]') }}</span></td>
                            <td><el-input v-model="dataDetail.Head.Finance_Date" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2179]') }}</span></td>
                            <td><el-input v-model="dataDetail.Head.issue_time" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[2180]') }}</span></td>
                            <td><el-select
                                    filterable class="mcolor"
                                    popper-class="select-option"
                                    :disabled="dataDetail.Head.Order_status == 1 ? true : false"
                                    v-model="dataDetail.Head.Issue_Dept"
                                    size="mini"
                            >
                                <el-option v-for="item in DeptList" :key="item.Code" :label="item.Name"
                                           :value="item.Name"></el-option>
                            </el-select></td>
                            <td><span>{{ $t('getapi[2205]') }}</span></td>
                            <td><el-input v-model="dataDetail.Head.remark" size="mini"></el-input></td>
                            <td><span v-show="IsShowOldOrderNo">{{ $t('getapi[2203]') }}</span></td>
                            <td><el-input v-show="IsShowOldOrderNo" v-model="dataDetail.Head.Relation_Blue_Order_No" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1864]') }}</span></td>
                            <td><!--<el-input class="mcolor"
                                          v-model="dataDetail.Head.Keep_Person"
                                          @click.native.prevent="selectEmployee(1)"
                                          size="mini"
                                          :disabled="dataDetail.Head.Order_status == 1 ? true : false"
                            ></el-input>-->
                                <routejump :urlNo="6">
                                    <el-input
                                            v-model="dataDetail.Head.Keep_Person"
                                            type="text"
                                            class="mcolor"
                                            :disabled="dataDetail.Head.Order_status == 1 ? true : false"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectEmployee(1)"></i>

                                    </el-input>
                                </routejump>
                            </td>
                            <td><span>{{ $t('getapi[7546]') }}</span></td>
                            <td><el-input
                                    v-model="dataDetail.Head.picker"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectpicker()"></i>
                            </el-input></td>
                            <td colspan="2">
                                <span>{{ $t('getapi[2096]') }}</span>
                                <el-checkbox v-model="dataDetail.Head.Negative_Flag" style="margin-left:0px"
                                             disabled></el-checkbox>
                            </td>
                            <td><span>{{ $t('getapi[4642]') }}</span></td>
                            <td style="width:150px;min-width:150px">
                                <!-- <routejump :urlNo="41" v-show="dataDetail.Head.Order_status == 0 "> -->
                                    <el-input  type="text" 
                                            v-model="dataDetail.Head.coll_sign"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-show="dataDetail.Head.Order_status == 0 && dataDetail.Head.Order_No == '' && disabled_coll_sign "
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix"  @click="selectsocode()"></i>
                                    </el-input>
                                <!-- </routejump> -->
                                <el-input type="text" size="mini" v-model="dataDetail.Head.coll_sign" v-show="((dataDetail.Head.Order_status != 0 && disabled_coll_sign) ||(dataDetail.Head.Order_No!='' && disabled_coll_sign)) " :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-row>
                    <el-col :span="24">
                        <div class="box" style="margin-top: 2px">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="mini" :disabled="!btn.addma"
                                           @click="addline">{{ $t('getapi[6092]') }}
                                </el-button>
                                <el-button type="primary" @click="batchDel" size="mini" icon="el-icon-delete-solid"
                                           :disabled="!btn.rowdel">{{ $t('getapi[3889]') }}
                                </el-button>
                                <!-- <el-button type="primary" :disabled="isBtnSaveDisable" size="mini" @click="save">{{$t('getapi[937]')}}</el-button> -->
                                <!-- <el-button type="primary" size="mini" @click="execute" :disabled="isBtnExecuteDisable">{{$t('getapi[2105]')}}</el-button> -->
                            </div>
                        </div>
                        <el-tabs type="" @tab-click="tabClick" style="margin-top: 1px">
                            <el-tab-pane :label="$t('getapi[2189]')" name="0" id="xdetilpane-0">
                                <el-table
                                        :data="dataSetMain"
                                        v-loading="dloading"
                                        header-row-class-name="headerclass"
                                        :row-class-name="tableRowClassNameRight"
                                        :highlight-current-row="true"
                                        border
                                        :height="tableHeight - 200"
                                        @selection-change="handleSelectionChangeMain"
                                        size="mini"
                                        style="width: 100%; margin-top:2px"
                                        @sort-change="sortChange"
                                        ref="singleTable1"
                                >
                                    <el-table-column type="selection" width="20"></el-table-column>
                                    <el-table-column show-overflow-tooltip width="60" prop="line_No"
                                                     :label="$t('getapi[1425]')" sortable></el-table-column>
                                    <!--<el-table-column show-overflow-tooltip prop="Line_status_Name"
                                                     :label="$t('getapi[552]')" sortable></el-table-column>-->
                                    <el-table-column show-overflow-tooltip prop="part_code"
                                                     :label="$t('getapi[112]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_name"
                                                     :label="$t('getapi[116]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_version"
                                                     :label="$t('getapi[149]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="specification"
                                                     :label="$t('getapi[125]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_stuff"
                                                     :label="$t('getapi[126]')" sortable></el-table-column>
                                    <el-table-column show-footer-overflow field="part_groupid"   v-if="false"></el-table-column>                            
                                    <el-table-column field="freevalue" :label="$t('getapi[8958]')" sortable width="100">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.freevalue" type="text" readonly
                                                    size="mini" v-if="dataDetail.Head.Order_status == 0 && freevalue">
                                                <i v-if="dataDetail.Head.Negative_Flag==false " class="el-icon-edit el-input__icon" slot="suffix"
                                                @click="getpartgroup(scope)"></i>
                                            </el-input>
                                            <span v-if="dataDetail.Head.Order_status != 0 ">{{scope.row.freevalue}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="right" prop="plan_qty" :label="$t('getapi[1628]')" sortable>
                                        <template scope="scope">
                                            <el-input v-if="editif" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                      v-model="scope.row.plan_qty"
                                                      @change="sum(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.plan_qty }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column show-overflow-tooltip prop="MeasureUnit"
                                                     :label="$t('getapi[3100]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip align="right" prop="invqty"
                                                     :label="$t('getapi[2920]')" sortable></el-table-column>
                                    <el-table-column prop="customer_code" :label="$t('getapi[2610]')" sortable>
                                        <template slot-scope="scope" v-show="false">
                                            <el-input v-if="editif" v-model="scope.row.customer_code"
                                                      @click.native.prevent="showCustomPop(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.customer_code }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="item_code" :label="$t('getapi[3437]')" sortable>
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.item_code"
                                                      @click.native.prevent="showProjectPop(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.item_code }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')" sortable>
                                    </el-table-column>
                                    <el-table-column prop="remark" :label="$t('getapi[1509]')" width="100">
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.remark"></el-input>
                                            <span v-if="!editif">{{scope.row.remark}} </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="new_part_code" :label="$t('getapi[13106]')" width="100">
                                        <template slot-scope="scope">
                                            <routejump :urlNo="12" :calssType="1">
                                                <el-input
                                                        v-model="scope.row.new_part_code"
                                                        type="text"
                                                        class="mcolor"
                                                        size="mini"
                                                        :readonly="true"
                                                        v-if="editif && canEditOldP && !dataDetail.Head.Negative_Flag"
                                                >
                                                    <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectNewProject(1,scope)"></i>

                                                </el-input>
                                            </routejump>
                                            <span v-if="!editif || !canEditOldP || dataDetail.Head.Negative_Flag">{{scope.row.new_part_code}} </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="new_part_version" :label="$t('getapi[13107]')" width="100"></el-table-column>
                                    <el-table-column prop="line_net_amount" :label="$t('getapi[1599]')" width="100">
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.line_net_amount"></el-input>
                                            <span v-if="!editif">{{scope.row.line_net_amount}} </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[2200]')" name="1" id="xdetilpane-1">
                                <el-table
                                        :data="dataSetAssist"
                                        v-loading="dloading"
                                        header-row-class-name="headerclass"
                                        :highlight-current-row="true"
                                        :row-class-name="tableRowClassNameRightAssist"
                                        border
                                        :height="tableHeight - 200"
                                        @selection-change="handleSelectionChangeAssist"
                                        show-overflow-tooltip="true"
                                        size="mini"
                                        style="width: 100%; margin-top:2px"
                                        @sort-change="sortChangeAssis"
                                        ref="singleTable2"
                                >
                                    <el-table-column type="selection" width="20"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="line_No" width="60"
                                                     :label="$t('getapi[1425]')" sortable></el-table-column>
                                    <!--<el-table-column show-overflow-tooltip prop="Line_status_Name"
                                                     :label="$t('getapi[552]')" sortable></el-table-column>-->
                                    <el-table-column show-overflow-tooltip prop="part_code"
                                                     :label="$t('getapi[112]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_name"
                                                     :label="$t('getapi[116]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_version"
                                                     :label="$t('getapi[149]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="specification"
                                                     :label="$t('getapi[125]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="part_stuff"
                                                     :label="$t('getapi[126]')" sortable></el-table-column>
                                    <el-table-column show-footer-overflow field="part_groupid"   v-if="false"></el-table-column>                            
                                    <el-table-column field="freevalue" :label="$t('getapi[8958]')" sortable width="100">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.freevalue" type="text" readonly
                                                    size="mini" v-if="dataDetail.Head.Order_status == 0 && freevalue">
                                                <i v-if="dataDetail.Head.Negative_Flag==false" class="el-icon-edit el-input__icon" slot="suffix"
                                                @click="getassistpartgroup(scope)"></i>
                                            </el-input>
                                            <span v-if="dataDetail.Head.Order_status != 0">{{scope.row.freevalue}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="right" width="100" prop="plan_qty"
                                                     :label="$t('getapi[1628]')" sortable>
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.plan_qty" @change="changeMergeQty(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.plan_qty }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[3599]')" align="right">
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="MeasureUnit"
                                                     :label="$t('getapi[3100]')" sortable></el-table-column>
                                    <el-table-column align="right" prop="Assist_plan_qty" :label="$t('getapi[4519]')" sortable>
                                        <template slot-scope="scope" >
                                            <el-input v-if="editif" v-model="scope.row.Assist_plan_qty" @input="calculate(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.Assist_plan_qty }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Assist_MeasureUnit"
                                                     :label="$t('getapi[130]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip align="right" prop="invqty"
                                                     :label="$t('getapi[2920]')" sortable></el-table-column>
                                    <el-table-column show-overflow-tooltip align="right" prop="assist_qty_on_hand"
                                                     :label="$t('getapi[6420]')" sortable></el-table-column>
                                    <el-table-column prop="customer_code" :label="$t('getapi[2610]')" sortable>
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.customer_code"
                                                      @click.native.prevent="showCustomPop(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.customer_code }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="item_code" :label="$t('getapi[3437]')" sortable>
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.item_code"
                                                      @click.native.prevent="showProjectPop(scope)"></el-input>
                                            <span v-if="!editif">{{ scope.row.item_code }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')" sortable></el-table-column>
                                    <el-table-column prop="remark" :label="$t('getapi[1509]')" sortable>
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" size="mini" v-model="scope.row.remark"></el-input>
                                            <span v-if="!editif">{{ scope.row.remark }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="new_part_code" :label="$t('getapi[13106]')" width="100">
                                        <template slot-scope="scope">
                                            <routejump :urlNo="12" :calssType="1">
                                                <el-input
                                                        v-model="scope.row.new_part_code"
                                                        type="text"
                                                        class="mcolor"
                                                        size="mini"
                                                        :readonly="true"
                                                        v-if="dataDetail.Head.Order_status == 0 && editif && canEditOldP && !dataDetail.Head.Negative_Flag"
                                                >
                                                    <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectNewProject(2,scope)"></i>

                                                </el-input>
                                            </routejump>
                                            <span v-if="dataDetail.Head.Order_status != 0 || !editif || !canEditOldP || dataDetail.Head.Negative_Flag">{{scope.row.new_part_code}} </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="new_part_version" :label="$t('getapi[13107]')" width="100"></el-table-column>
                                    <el-table-column prop="line_net_amount" :label="$t('getapi[1599]')" width="100">
                                        <template slot-scope="scope">
                                            <el-input v-if="editif" v-model="scope.row.line_net_amount"></el-input>
                                            <span v-if="!editif">{{scope.row.line_net_amount}} </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!-- 分页 -->
                            </el-tab-pane>
                            <el-tab-pane v-if="disabled_SoLists" :label="$t('getapi[4653]')" name="2">
                            <el-table
                                    id="xdetilpane-2"
                                    :data="SoLists"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 185"
                                    header-row-class-name="headerclass"
                                    border
                                    v-if="disabled_SoLists"
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    ref="singleTable4"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_desc" :label="$t('getapi[575]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[916]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[4245]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[4654]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[6421]')">
                                <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        :action="uploadurl"
                                        :on-preview="handlePreview"
                                        :on-remove="handleRemove"
                                        :on-change="handleChange"
                                        :on-success="handleSuccess"
                                        :on-error="handleError"
                                        :before-upload="beforeAvatarUpload"
                                        :file-list="fileList"
                                        :data="fileparm"
                                        :limit="1"
                                >
                                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6422]')}}</el-button>
                                    <div slot="tip" class="el-upload__tip"></div>
                                </el-upload>
                                <el-table
                                        :data="dataDetail.attr"
                                        v-loading="loading"
                                        :highlight-current-row="false"
                                        show-overflow-tooltip="true"
                                        border
                                        stripe
                                        size="mini"
                                        header-row-class-name="headerclass"
                                >
                                    <el-table-column show-overflow-tooltip prop="Node_Name"
                                                     :label="$t('getapi[3590]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Type"
                                                     :label="$t('getapi[6423]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Doc_Size"
                                                     :label="$t('getapi[7875]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Person"
                                                     :label="$t('getapi[6425]')"></el-table-column>
                                    <el-table-column show-overflow-tooltip prop="Upload_Time"
                                                     :label="$t('getapi[6426]')"></el-table-column>
                                    <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                        <template slot-scope="scope">
                                            <el-button @click.native.prevent="open(scope)" type="text" size="mini">{{
                                                $t('getapi[3611]') }}
                                            </el-button>
                                            <el-button @click.native.prevent="filedel(scope)" type="text" size="mini">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="InvissueManufactureViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[976]')" queryData="InvissueManufactureViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 详情页面 -->
        <inv-out-manager :isVisible="isVisible" ref="order"></inv-out-manager>
        <!--选择保管员 输出，输入-->
        <!-- <employee :isVisible="KeeperVisible" @getemployee="getkeeper" ref="inputemp"></employee> -->
        <selector :isVisible="KeeperVisible" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getkeeper" ref="inputemp"></selector>
        <!--选择记账员 -->
        <!-- <employee :isVisible="AccounterVisible" @getemployee="getaccounter" ref="inputempp"></employee> -->
        <selector :isVisible="AccounterVisible" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getaccounter" ref="inputempp"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/GetPickerList'" @callback="getpicker" ref="picker"></selector>
        <!--主计量物料选择 -->
        <!-- <OM :isVisible="materialsVisible" @addmaterials="callbackmaterial" ref="inputmaterialtype"></OM> -->

        <selector :isVisible="materialsVisible" :selectType="7" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="callbackmaterial"
                  ref="inputmaterialtype"></selector>
        <selector :isVisible="materialsVisible" :selectType="8" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="callbackmaterial"
                  ref="inputmaterialtype8"></selector>


        <!--客户代码 -->
        <!-- <customer :isVisible="isShowCustomer" @getcustomer="callbackcustomer" ref="inputcustomer"></customer> -->
        <selector :isVisible="isShowCustomer" :isBatch=false :isSplitPage=true :selectType=cusselectType
                  :postUrl="'/Basic/Popup/GetCustomerDataList'" @callback="callbackcustomer"
                  ref="inputcustomer"></selector>
        <!--项目代码 -->
        <!-- <itemCode :isVisible="isShowItem" @getproject="callbackproject" ref="inputitemcode"></itemCode> -->
        <selector :isVisible="isShowItem" :isBatch=false :isSplitPage=true :selectType="5"  :postUrl="'/Basic/Popup/GetEngItemDataList'"
                  @callback="callbackproject" ref="inputitemcode"></selector>

        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupInvView'" @callback="partgroup"
                  ref="partgroup"></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupInvView'" @callback="assistpartgroup"
                  ref="assistpartgroup"></selector>

        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :selectType="17"
                  :postUrl="'Basic/Popup/GetPartPopuDataList'" @callback="getNewProject1"
                  ref="newproject1"></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :selectType="18"
                  :postUrl="'Basic/Popup/GetPartPopuDataList'" @callback="getNewProject2"
                  ref="newproject2"></selector>
         <!--选择SO号-->
         <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/UniversalOut/GetBoardMergePopupDataList'" @callback="getsocode" ref="socode"></selector>


        <el-dialog v-dialogDrag :visible.sync="visDetailPrintType" width="15%" :close-on-click-modal="false">
            <el-form>
                <el-form-item>
                    <div v-for="(item, index) in dataPrint" :key="index">
                        <el-form-item>
                            <el-radio v-model="radio" :label="item.Num" @change="(val)=>{changePrint(val,item.Code)}">{{item.Name}}</el-radio>
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visDetailPrintType = false" size="mini">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmPrint" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import InvOutManager from './InvOutManager';
    import {Loading} from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        components: {InvOutManager},
        name: 'InvOutView',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('InvOutView'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dloading: false,//子表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {},
                    line: [],
                    attr: [],
                }, // 编辑页面数据详情
                dataSetMain: [],
                dataSetAssist: [],
                SoLists:[],
                oldDataDetail: '',
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                nowPOCode: 0, // 当前单号
                //**********子编辑页面参数************
                editif: false,
                // isBtnAddDisable:false,
                // isBtnExecuteDisable:true,
                // isBtnSaveDisable:false,
                materialsVisible: false,
                IsNew: false, //是否新增操作
                canmodifykeepaccounttime: false, //允许修改建单时间
                IsCreatingRed: false, //正在生成红单
                IsShowOldOrderNo: false, //是否显示原单号
                isBtnNegative: false, //是红单亮
                lineno: 0, //当前最大行号
                NowCustomerIndex: 0, //当前客户代码
                NowProjectIndex: 0, //当前项目代码index
                isShowItem: false,
                isShowCustomer: false, //是否显示客户代码选项 下拉
                //Head: {},
                IsMain: true, //主Tab页是否被选择
                KeeperVisible: false,
                AccounterVisible: false,
                vis: this.isVisible, // 是否显示弹窗，
                ArrayIssueType: [], // 出库类型
                DeptList: [], //领料部门
                // ArrayTransMode: [], // 运输方式
                supplierVisible: false,
                //dataSetMain: [], // 主表数据
                //dataSetAssist: [], //次主表数据
                multipleSelectionMain: [],
                multipleSelectionAssist: [],
                totalMain: 0,
                totalAssist: 0,
                user: '',
                btn: {
                    addma: false,
                    rowdel: false,
                    red: false
                },
                // 上传清单
                uploadurl: '',
                fileparm: {
                    code: '',
                    data_type: 9,
                    Login_Group:'',
                    Login_DB:'',
                },
                fileList: [],
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                RightSelectIndex: '0',
                canEditOldP: false, // 是否可编辑老物料编码和版本
                //自由项
                freevalue: false,
                //自由项配置
                freeConfig:0,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                disabled_issue_type_ID:false,
                disabled_coll_sign:false,
                disabled_SoLists:false,
                cusselectType:0,
                //打印
                dataPrint: [], //打印模板
                tempname: '',// 选中的模板名称
                visDetailPrintType:false,
                radio: '0',
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            // that.uploadurl = Common.FileUrl+ '/Basic/UploadFilesResult?token=' + token;
            that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
        },
        
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.freeConfig=Array.methods.getSysConfig('A104');
            that.$processdata.pushModelCache('InvOutView', that)
            that.PlanTypeArray = Array.methods.getPlanType();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.ArrayIssueType = Array.methods.ArrayIssueType();
            that.DeptList = Array.methods.getIssueDeptList();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.$limits.dragControllerDiv();
            that.confirmAdd();
            ///物料自由项是否启用
            if(that.freeConfig== 1){
                that.freevalue = true
            }
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[976]"),this.$t("getapi[15]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('InvissueManufactureViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                that.disabled_SoLists=false;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!this.$limits.menuvisible("plv2", 282, 1)) {
                    var value = that.$limits.newOperationAuthorityView('plv2', 95, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 282, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 282, 1) == 2) {
                        if (that.$limits.authority('plv3', 282, 1) == 0) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 282, 1) == 1) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                                if (that.dataDetail.Head.Order_status == 1) { // =1 关闭状态
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,preview,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,preview');
                                }
                                //红字，不可增加或者删除

                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 282, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                                if (that.dataDetail.Head.Order_status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,preview,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,preview,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                
                 if(that.dataDetail.Head.Order_status==1){
                    that.editif=false;
                 }
                 else{
                    that.editif=true;
                 }
                that.$refs.SetBtn.InputBtnRight('T13_MaterialIssue');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                if(that.dataDetail.Head.Order_status == 1){
                    that.disabled_issue_type_ID=true;
                }
                else{
                    that.disabled_issue_type_ID=false;
                }
                for(let i = 0;i<that.ArrayIssueType.length;i++){
                    if(that.dataDetail.Head.issue_type_ID == that.ArrayIssueType[i].Code){
                        if(that.ArrayIssueType[i].Name == '换号出库'){
                            that.canEditOldP = true
                        } else {
                            that.canEditOldP = false
                            for(let i=0;i<that.dataSetMain.length;i++){
                                if(that.dataSetMain[i].new_part_code && that.dataSetMain[i].new_part_version){
                                    that.dataSetMain[i].new_part_code = ''
                                    that.dataSetMain[i].new_part_version = ''
                                }
                            }
                            for(let i=0;i<that.dataSetAssist.length;i++){
                                if(that.dataSetAssist[i].new_part_code && that.dataSetAssist[i].new_part_version){
                                    that.dataSetAssist[i].new_part_code = ''
                                    that.dataSetAssist[i].new_part_version = ''
                                }
                            }
                        }
                        if( that.ArrayIssueType[i].Name != '研发出库'){
                            that.disabled_coll_sign=false;
                        }
                        else{
                            if(that.$limits.authority('plv4', 590, 1)>0){
                                if(that.dataDetail.Head.Negative_Flag == false){
                                    that.disabled_coll_sign=true;
                                }
                            }
                            else{
                                that.disabled_coll_sign=false;
                            }
                        }
                    }
                }
                /*if(that.$limits.authority('plv4', 590, 1)>0){
                    if(that.dataDetail.Head.Negative_Flag == false){
                        that.disabled_coll_sign=true;
                    }
                }
                else{
                    that.disabled_coll_sign=false;
                }*/
                

                if (that.$limits.authority('plv3', 282, 1) < 0) {
                    that.btn.rowdel = false;
                } else {
                    if (that.$limits.authority('plv4', 184, 1) < 0) {
                        that.btn.rowdel = false;
                        that.btn.addma = false;
                    } else {
                        if (that.dataDetail.Head.Order_status != 0) {  //0 是生成状态
                            that.btn.rowdel = false;
                            that.btn.addma = false;
                        } else {
                            that.btn.rowdel = true;
                            that.btn.addma = true;
                        }
                    }
                }
                //生成红字
                if (that.dataDetail.Head.Negative_Flag == false && that.dataDetail.Head.Order_status > 0) {
                    if (that.$limits.authority('plv4', 330, 1) == 0) {
                        that.btn.red = false;
                    } else {
                        that.btn.red = true;
                    }
                } else {
                    that.btn.red = false;
                }

                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No) && that.dataDetail.Head.Order_status == 0) {
                    
                    /*if (that.$limits.authority('plv4', 331, 1) == 0 || that.dataDetail.Head.Finance_StatusString == '月结') {
                        //执行记账 false
                        that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute',true);//加了delete
                    }*/
                    if (that.dataDetail.Head.Negative_Flag == false) {
                        if (that.$limits.authority('plv2', 283, 1) > 0) {
                            that.$refs.SetBtn.SetOneBtnEnable('execute', true)
                        } else {
                            that.$refs.SetBtn.SetOneBtnEnable('execute', false)
                        }
                    } else {
                        if (that.$limits.authority('plv2', 284, 1) > 0) {
                            that.$refs.SetBtn.SetOneBtnEnable('execute', true)
                        } else {
                            that.$refs.SetBtn.SetOneBtnEnable('execute', false)
                        }
                    }
                    if (!that.dataDetail.Head.Negative_Flag) {
                        that.btn.rowdel = true;
                        that.btn.addma = true;
                    }
                }
                //红字不可增加与删除
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                    if (that.dataDetail.Head.Negative_Flag) {
                        that.btn.rowdel = false;
                        that.btn.addma = false;
                    }
                }
                //板材发料
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)) {
                    that.btn.rowdel = false;
                    that.btn.addma = false;
                    that.disabled_issue_type_ID=true;
                    that.disabled_SoLists=true;
                }
            },
            selectsocode(){
                let that = this;
                if(that.dataDetail.Head.Negative_Flag==false){
                    that.$refs.socode.clearInput(true);
                }
            },
            getsocode(data){
                let that = this
                that.dataDetail.Head.coll_sign = data.coll_sign

                for(let i = 0;i<that.ArrayIssueType.length;i++){                    
                    if( that.ArrayIssueType[i].Name == '研发出库'){
                        that.dataDetail.Head.issue_type_ID = that.ArrayIssueType[i].Code;
                    }
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)) {
                    that.btn.rowdel = false;
                    that.btn.addma = false;
                    that.disabled_issue_type_ID=true;
                    that.disabled_SoLists=true;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    coll_sign: data.coll_sign,
                    negative_flag: that.dataDetail.Head.Negative_Flag,
                    rd_customer_code:data.rd_customer_code
                }
                
                that.$http.urlpost('/Inv/UniversalOut/GetSelCollSignLoadInfo', parm, function (res) {
                    if (res.Success == 1) {
                        let M = res.DataContent.MergeLists
                        let MdataDetailLineNo = 1
                        that.dataSetAssist = []
                        for (let i = 0; i < that.dataSetAssist.length; i++) {
                            if (that.dataSetAssist[i].line_no >= MdataDetailLineNo) {
                                MdataDetailLineNo = that.dataSetAssist[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<M.length;i++){
                            that.dataSetAssist = [...that.dataSetAssist,{
                                Exclusively_Id: 0,
                                Relation_Order_No: that.dataDetail.Head.Order_No,
                                line_No: MdataDetailLineNo++,
                                Line_status: 0,
                                Line_status_Name: '生成',
                                part_id: M[i].part_id,
                                part_code: M[i].part_code,
                                part_version: M[i].part_version,
                                part_name: M[i].part_name,
                                specification: M[i].part_spec,
                                model: M[i].part_model,
                                MeasureUnit: M[i].MeasureUnit,
                                Assist_MeasureUnit: M[i].Assist_MeasureUnit,
                                part_stuff:M[i].part_stuff,
                                mp_flag: M[i].mp_flag,
                                plan_qty: M[i].plan_qty,
                                Assist_plan_qty: M[i].Assist_plan_qty,
                                master_assist_rate: M[i].master_assist_rate,
                                invqty: M[i].qty_on_hand,
                                assist_qty_on_hand:M[i].assist_qty_on_hand,                                
                                customer_code: data.rd_customer_code,
                                item_code: M[i].item_code,
                                item_name: M[i].item_name,
                                part_groupid : '',
                                freevalue : '',
                            }]
                        }

                        
                        let S = res.DataContent.SoLists
                        let SdataDetailLineNo = 1
                        that.SoLists = []
                        for (let i = 0; i < that.SoLists.length; i++) {
                            if (that.SoLists[i].line_no >= SdataDetailLineNo) {
                                SdataDetailLineNo = that.SoLists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<S.length;i++){
                            that.SoLists = [...that.SoLists,{
                                exclusively_id: S[i].exclusively_id,
                                relation_order_no: S[i].relation_order_no,
                                line_no: SdataDetailLineNo++,
                                part_id: S[i].part_id,
                                part_code: S[i].part_code,
                                part_version: S[i].part_version,
                                part_name: S[i].part_name,
                                part_spec: S[i].part_spec,
                                part_model: S[i].part_model,
                                so_code: S[i].so_code,
                                routing_sequence_no: S[i].routing_sequence_no,
                                routing_desc: S[i].routing_desc,
                                measure_unit: S[i].measure_unit,
                                plan_qty: S[i].plan_qty,
                                actually_avg_qty: S[i].actually_avg_qty,
                                unit_price: S[i].unit_price,
                                line_net_total_amount: S[i].line_net_total_amount,
                                line_remark: S[i].line_remark
                            }]
                        }
                        
                        for(let i = 0;i<that.dataSetAssist.length;i++){
                            that.dataSetAssist[i].plan_qty = (that.dataSetAssist[i].Assist_plan_qty * that.dataSetAssist[i].master_assist_rate).toFixed(4)
                            that.setSoQty(that.dataSetAssist[i])
                        }
                        for(let i = 0;i<that.dataSetAssist.length;i++){
                            let newAssistQty = that.dataSetAssist[i].plan_qty / that.dataSetAssist[i].master_assist_rate
                            if(that.dataSetAssist[i].Assist_plan_qty - newAssistQty > 1){
                                that.$message.warning(that.$t('getapi[4674]'))//板材重量的调整超出了一张板的限额，请重新检查
                                that.dataSetAssist[i].plan_qty = (that.dataSetAssist[i].Assist_plan_qty * that.dataSetAssist[i].master_assist_rate).toFixed(4)
                            } else {
                                that.setSoQty(that.dataSetAssist[i])
                            }
                        }
                    }
                });
            },
            changeMergeQty(row){
                let that = this
                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){
                    let newAssistQty = row.row.plan_qty / row.row.master_assist_rate
                    if(row.row.Assist_plan_qty - newAssistQty > 1){
                        that.$message.warning(that.$t('getapi[4674]'))//'板材重量的调整超出了一张板的限额，请重新检查'
                        row.row.plan_qty = (row.row.assist_merge_qty * row.row.master_assist_rate).toFixed(4)
                    } else {
                        that.setSoQty(row.row)
                    }
                }
            },
            calculate(row) {
                //根据次计量 算出主计量数量
                let that = this
                let index = row.$index;              
                let qty = that.dataSetAssist[index].master_assist_rate * that.dataSetAssist[index].Assist_plan_qty;
                that.dataSetAssist[index].plan_qty = qty.toFixed(4);

                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){
                    that.setSoQty(row.row);
                }
                //that.dataSetAssist[index].Assist_plan_qty = that.dataSetAssist[index].Assist_plan_qty.toFixed(4);
            },
            setSoQty(row){
                let that = this
                let SumPlanQty
                let ActualQty
                let MergeQty
                let PartID
                let RealityQty
                SumPlanQty = 0
                MergeQty = 0
                ActualQty = 0
                PartID = ""
                RealityQty = 0
                PartID = row.part_id
                MergeQty = parseFloat(row.plan_qty)

                for (let j = 0; j < that.SoLists.length; j++)
                {
                    if (PartID == that.SoLists[j].part_id)
                    {
                        SumPlanQty = SumPlanQty + parseFloat(that.SoLists[j].plan_qty);
                    }
                }
                for (let j = 0; j < that.SoLists.length; j++)
                {
                    if (PartID == that.SoLists[j].part_id)
                    {
                        ActualQty = MergeQty * parseFloat(that.SoLists[j].plan_qty) / SumPlanQty;
                        that.SoLists[j].actually_avg_qty = ActualQty.toFixed(4);
                        RealityQty = RealityQty + parseFloat(that.SoLists[j].actually_avg_qty)
                    }
                }
                if (RealityQty != MergeQty && that.SoLists.length > 0)
                {
                    for (let i = 0; i < that.SoLists.length; i++)
                    {
                        if (that.SoLists[i].actually_avg_qty != 0)
                        {
                            that.SoLists[i].actually_avg_qty = that.$processdata.mathRound4(parseFloat(that.SoLists[i].actually_avg_qty) + MergeQty - RealityQty);
                            break;
                        }
                    }
                }
            },
            handleChange(file, fileList) {
                let that = this;
                console.log('------handleChange---', file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        //
                        // that.datajson = file.response.DataContent;
                    }
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    let parm = {
                        Code: that.dataDetail.Head.Order_No,
                        List: []
                    };
                    that.getDetail(parm);
                    that.$refs.upload.clearFiles();
                }
            },
            getassistpartgroup(data) {
                let that = this;
                that.rowindex = data.$index;
                let param = {
                    part_code:that.dataSetAssist[that.rowindex].part_code,
                    part_version:that.dataSetAssist[that.rowindex].part_version,
                    type:2,
                };
                if (that.freeConfig == 1) {
                    that.$refs.assistpartgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            assistpartgroup(data){
                let that = this;
                that.dataSetAssist[that.rowindex].freevalue = data.freevalue;
                that.dataSetAssist[that.rowindex].part_groupid = data.exclusively_id;  
                that.dataSetAssist[that.rowindex].invqty = data.qty_on_hand; 
                that.dataSetAssist[that.rowindex].assist_qty_on_hand = data.assist_qty_on_hand;               
            },
            
            getpartgroup(data) {
                let that = this;
                that.rowindex = data.$index;
                let param = {
                    part_code:that.dataSetMain[that.rowindex].part_code,
                    part_version:that.dataSetMain[that.rowindex].part_version,
                    type:1,
                };
                if (that.freeConfig == 1) {
                    that.$refs.partgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            partgroup(data){
                let that = this;
                that.dataSetMain[that.rowindex].freevalue = data.freevalue;
                that.dataSetMain[that.rowindex].part_groupid = data.exclusively_id;  
                that.dataSetMain[that.rowindex].invqty = data.qty_on_hand; 
                              
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                let that = this;
                console.log("上传2");
                that.fileparm.code = that.dataDetail.Head.Order_No;
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            beforeAvatarUpload(file) {
                let that = this;
                console.log("上传");
                that.fileparm.code = that.dataDetail.Head.Order_No;
                if (that.dataDetail.Head.Order_No == '' || that.dataDetail.Head.Order_No == null) {
                    that.$message.error(that.$t('getapi[8619]'));//单据号不能为空
                    return false;
                }
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                    return true;
            },
            open(row) {
                let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
                // if (!that.$limits.fnIsEmpty(row.row.path)) {
                //     window.open(row.row.path);
                // }
            },

            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        console.log("删除数据");

                        console.log("删除数据单据号：" + that.dataDetail.Head.Order_No);
                        console.log("删除数据时间戳：" + that.dataDetail.Head.lastedittime);

                        let parm = {
                            order_no: that.dataDetail.Head.Order_No,
                            lastedittime: that.dataDetail.Head.lastedittime,
                            lists: []
                        };
                        if (that.IsMain) {
                            for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                                that.dataSetMain.splice(that.multipleSelectionMain[i].index, 1);
                                if (!that.$limits.fnIsEmpty(that.multipleSelectionMain[i].Exclusively_Id)) {
                                    let datatmp = {
                                        exclusively_id: that.multipleSelectionMain[i].Exclusively_Id,
                                    }
                                    parm.lists.push(datatmp);
                                }
                            }
                        }
                        else {
                            for (let i = that.multipleSelectionAssist.length - 1; i >= 0; i--) {
                                that.dataSetAssist.splice(that.multipleSelectionAssist[i].index, 1);
                                if (!that.$limits.fnIsEmpty(that.multipleSelectionAssist[i].Exclusively_Id)) {
                                    let datatmp = {
                                        exclusively_id: that.multipleSelectionAssist[i].Exclusively_Id,
                                    }
                                    parm.lists.push(datatmp);
                                }
                            }
                        }
                        if (parm.lists.length > 0) {
                            that.$http.urlpost('/Inv/UniversalOut/DelLineInvIssue', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    let parm = {
                                        Code: that.dataDetail.Head.Order_No,
                                        List: []
                                    };
                                    that.getDetail(parm);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //删除文件
            filedel(row) {
                let that = this;
                let index = row.$index;
                that.ids = '';
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.path == 'undefined' ? '' : row.row.path;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                                that.dataDetail.attr.splice(index, 1);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            deldata() {
                let that = this
                this.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'您确定要删除该单据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {
                    let that = this;
                    if (that.dataDetail.Head.Order_No == '' || that.dataDetail.Head.Order_No == undefined) return;
                    let jdata = {
                        order_no: that.dataDetail.Head.Order_No,
                        lastedittime: that.dataDetail.Head.lastedittime
                    }
                    that.$http.urlpost('/Inv/UniversalOut/DelInvIssue', jdata, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            that.confirmAdd();//清空右边
                            that.reflash();//刷新左边
                        }
                    });

                }).catch(() => {
                    // this.$message({
                    // type: 'info',
                    // message: '已取消删除'
                    // });
                });

            },
            save() {
                let that = this;
                let parm = {
                    head: that.dataDetail.Head,
                    line: [],
                    LangType: that.$processdata.getLang(),
                    SoLists:that.SoLists,
                };
                if (that.dataDetail.Head.issue_type_ID == undefined) {
                    that.$message.warning(that.$t('getapi[8621]'));//'出库类型不能为空！'
                    return;
                }
                if (that.dataDetail.Head.Keep_Person == '') {
                    that.$message.warning(that.$t('getapi[2886]'));//'保管员不能为空！'
                    return;
                }
                // if (that.dataDetail.Head.Regist_Person == '') {
                //     that.$message.warning('记账员不能为空！');
                //     return;
                // }
                if (that.dataDetail.Head.Issue_Dept == '') {
                    that.$message.warning(that.$t('getapi[4542]'));//'领料部门必须选择！'
                    return;
                }
                
                for(let i = 0;i<that.ArrayIssueType.length;i++){
                    if(that.dataDetail.Head.issue_type_ID == that.ArrayIssueType[i].Code){
                        if(that.dataDetail.Head.picker == '' && that.ArrayIssueType[i].Name == '研发出库'){
                            that.$message.warning(that.$t('getapi[8622]'));//出库类型为研发出库，领料人必须选择！
                            return;
                        }
                    }
                }
                for (let i = 0; i < that.dataSetMain.length; i++) {
                    // if(that.userData.Login_DB.toLowerCase()=="my"){
                    //     // if (that.$limits.fnIsEmpty(that.dataSetMain[i].line_net_amount)) {
                    //     //     that.$message.warning(that.$t('getapi[13435]'));
                    //     //     return;
                    //     // }                            
                    // }
                    
                    parm.line.push(that.dataSetMain[i]);
                }
                for (let j = 0; j < that.dataSetAssist.length; j++) {
                    // if (that.dataSetAssist[j].customer_code == '' || that.dataSetAssist[j].customer_code == null) {
                    // 	that.$message.warning('客户代码不能为空！');
                    // 	return;
                    // }
                    parm.line.push(that.dataSetAssist[j]);
                }
                console.log(JSON.stringify(parm));
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Inv/UniversalOut/InvIssueSave', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    console.log(res);
                    if (res.Success == 1) {
                        if (that.IsCreatingRed || that.IsNew) {
                            that.$message.success(that.$t('getapi[2212]'));//'新建成功！'
                            that.IsNew = false;
                            that.IsCreatingRed = false;
                        } else {
                            that.$message.success(that.$t('getapi[2215]'));//'修改成功！'
                            that.isShowEdit = false;
                        }
                        that.nowPOCode = res.UniqueNum
                        let qdata = {
                            IID: '',
                            Code: res.UniqueNum,
                            Name: '',
                            Status: ''
                        };
                        that.getDetail(qdata);
                    }
                    that.vis = false;
                });
            },
            // 批量选择
            handleSelectionChangeMain(val) {
                //let that = this;
                this.multipleSelectionMain = val;
            },
            handleSelectionChangeAssist(val) {
                //let that = this;
                this.multipleSelectionAssist = val;
            },
            execute() {
                let that = this;
                that.$store.commit('setSharedParams',{
                    order_no: that.dataDetail.Head.Order_No,
                    issue_type: that.dataDetail.Head.issue_type_Name,
                    lastedittime: that.dataDetail.Head.lastedittime,
                    relation_blue_order_no: that.dataDetail.Head.Relation_Blue_Order_No,
                    coll_sign:that.dataDetail.Head.coll_sign
                });
                if (that.dataDetail.Head.Negative_Flag) {
                    console.log("测试1")
                    let item = {
                        label: '通用出库红字执行',
                        name: 'generalred',
                        path: '/generalred/1',
                        url: '/generalred/1',
                        icon: 'video-play'
                    };
                    this.$router.push({path: '/generalred/1'});
                    this.$store.commit('selectMenu', item);
                    that.$limits.SaveKeepView(item);
                } else {
                    console.log("测试2")
                    let item = {
                        label: '通用出库执行',
                        name: 'general',
                        path: '/general/1',
                        url: '/general/1',
                        icon: 'video-play'
                    };
                    this.$router.push({path: '/general/1'});
                    this.$store.commit('selectMenu', item);
                    that.$limits.SaveKeepView(item);
                }
                that.vis = false;

            },
             SelissuetypeID() {
                let that = this;
                for(let i = 0;i<that.ArrayIssueType.length;i++){  
                    if(that.dataDetail.Head.issue_type_ID == that.ArrayIssueType[i].Code){
                        if(that.ArrayIssueType[i].Name == '换号出库'){
                            that.canEditOldP = true
                        } else {
                            that.canEditOldP = false
                            for(let i=0;i<that.dataSetMain.length;i++){
                                that.dataSetMain[i].new_part_code = ''
                                that.dataSetMain[i].new_part_version = ''
                            }
                            for(let i=0;i<that.dataSetAssist.length;i++){
                                that.dataSetMain[i].new_part_code = ''
                                that.dataSetMain[i].new_part_version = ''
                            }
                        }
                        if( that.ArrayIssueType[i].Name != '研发出库'){
                            that.disabled_coll_sign=false;
                        }
                        else{
                            if(that.$limits.authority('plv4', 590, 1)>0){
                                if(that.dataDetail.Head.Negative_Flag == false){
                                    that.disabled_coll_sign=true;
                                }
                            }
                            else{
                                that.disabled_coll_sign=false;
                            }
                        }
                    }
                }
            },
            //选取客户代码
            showCustomPop(val) {
                let that = this;
                that.NowCustomerIndex = val.$index;
                that.isShowCustomer = true;
                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){
                    that.cusselectType=1;
                }
                else{
                    that.cusselectType=0;
                }
                that.$refs.inputcustomer.clearInput(this.isShowCustomer, false, 0);
            },
            //选取项目号
            showProjectPop(val) {
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)) {
                    that.NowProjectIndex = val.$index;
                    that.isShowItem = true;

                    let param = {
                        issuetype:that.dataDetail.Head.issue_type_ID
                    };

                    that.$refs.inputitemcode.clearInput(this.isShowItem,param, false, 1);
                }
            },
            //获取保管员后赋值
            getkeeper(data) {
                let that = this;
                that.dataDetail.Head.Keep_Person = data.name;
            },
            //获取记账员后赋值
            getaccounter(data) {
                let that = this;
                that.dataDetail.Head.Regist_Person = data.name;
            },
            addline() {
                //弹框选择数据
                let that = this;
                that.materialsVisible = true;
                if (that.IsMain) that.$refs.inputmaterialtype.clearInput(true);
                else that.$refs.inputmaterialtype8.clearInput(true);
            },
            tableRowClassNameRight({row, rowIndex}) {
                row.index = rowIndex;
                if(row.Line_status != 1 && row.plan_qty > row.invqty){
                    return 'red'
                }
            },
            tableRowClassNameRightAssist({row, rowIndex}) {
                row.index = rowIndex;
                if(row.Line_status != 1 && row.plan_qty > row.invqty){
                    return 'red'
                }
            },
            delline() {
                let that = this;
                if (that.IsMain) {
                    for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                        that.dataSetMain.splice(that.multipleSelectionMain[i].index, 1);
                    }
                }
                else {
                    for (let i = that.multipleSelectionAssist.length - 1; i >= 0; i--) {
                        that.dataSetAssist.splice(that.multipleSelectionAssist[i].index, 1);
                    }
                }
            },
            callbackcustomer(data) {
                let that = this;
                if (that.IsMain) {
                    that.dataSetMain[that.NowCustomerIndex].customer_code = data.customer_id;
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){
                        that.dataSetMain[that.NowCustomerIndex].item_code = data.newitemname;
                        that.dataSetMain[that.NowCustomerIndex].item_name = data.newitemname;
                    }
                } else {
                    that.dataSetAssist[that.NowCustomerIndex].customer_code = data.customer_id;
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){
                        that.dataSetAssist[that.NowCustomerIndex].item_code = data.newitemname;
                        that.dataSetAssist[that.NowCustomerIndex].item_name = data.newitemname;
                    }
                }

            },
            callbackproject(data) {
                let that = this;
                if (that.IsMain) {
                    that.dataSetMain[that.NowProjectIndex].item_code = data.item_code;
                    that.dataSetMain[that.NowProjectIndex].item_name = data.item_name;
                    that.dataSetMain[that.NowProjectIndex].customer_code = data.customer_id;
                } else {
                    that.dataSetAssist[that.NowProjectIndex].item_code = data.item_code;
                    that.dataSetAssist[that.NowProjectIndex].item_name = data.item_name;
                    that.dataSetAssist[that.NowProjectIndex].customer_code = data.customer_id;                    
                }
            },
            //插入到表格中
            callbackmaterial(data) {
                let that = this
                if (that.IsMain) {
                    for (let i = 0; i < data.length; i++) {
                        that.lineno++
                        that.dataSetMain = [...that.dataSetMain, {
                            Exclusively_Id: 0,
                            Relation_Order_No: that.dataDetail.Head.Order_No,
                            line_No: that.lineno,
                            Line_status: 0,
                            Line_status_Name: '生成',
                            part_code: data[i].part_code,
                            part_name: data[i].part_name,
                            part_version: data[i].part_version,
                            mp_flag: data[i].mp_flag,
                            model: data[i].part_model,
                            specification: data[i].part_spec,
                            part_stuff:data[i].part_stuff,
                            plan_qty: 0,
                            actually_qty: 0,
                            MeasureUnit: data[i].part_master_unit,
                            Assist_plan_qty: 0,
                            Assist_actually_qty: 0,
                            Assist_MeasureUnit: data[i].part_assist_unit,
                            invqty: data[i].qty_on_hand,
                            master_assist_rate: data[i].master_assist_rate,
                            customer_code: '',
                            item_code: '',
                            part_groupid : '',
                            freevalue : '',
                            new_part_code:'',
                            new_part_version:'',
                        }]
                    }
                } else {
                    for (let i = 0; i < data.length; i++) {
                        that.lineno++
                        that.dataSetAssist = [...that.dataSetAssist, {
                            Exclusively_Id: 0,
                            Relation_Order_No: that.dataDetail.Head.Order_No,
                            line_No: that.lineno,
                            Line_status: 0,
                            Line_status_Name: '生成',
                            part_code: data[i].part_code,
                            part_name: data[i].part_name,
                            part_version: data[i].part_version,
                            mp_flag: data[i].mp_flag,
                            model: data[i].part_model,
                            specification: data[i].part_spec,
                            part_stuff:data[i].part_stuff,
                            plan_qty: 0,
                            actually_qty: 0,
                            MeasureUnit: data[i].part_master_unit,
                            Assist_plan_qty: 0,
                            Assist_actually_qty: 0,
                            Assist_MeasureUnit: data[i].part_assist_unit,
                            invqty: data[i].qty_on_hand,
                            assist_qty_on_hand: data[i].assist_qty_on_hand,
                            master_assist_rate: data[i].master_assist_rate,
                            customer_code: '',
                            item_code: '',
                            part_groupid : '',
                            freevalue : '',
                            new_part_code:'',
                            new_part_version:'',
                        }]
                    }
                }
            },
            //删除一行
            deleteline(row) {
                let that = this;
                if (that.IsMain) {
                    that.dataSetMain.splice(row.$index, 1);
                } else {
                    that.dataSetAssist.splice(row.$index, 1);
                }
            },
            tabClick(tab, event) {
                let that = this;
                if (tab.name === '0') that.IsMain = true;
                else that.IsMain = false;
                that.RightSelectIndex = tab.name
                this.$nextTick(function(){
                    this.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            selectEmployee(type) {
                let that = this;
                if (!that.editif) return;
                if (type == 1) {
                    that.KeeperVisible = true;
                    this.$refs.inputemp.clearInputFromFunc(that.KeeperVisible, false, 3);
                } else {
                    that.AccounterVisible = true;
                    this.$refs.inputempp.clearInputFromFunc(that.AccounterVisible, false, 3);
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('InvOutView',val)
                this.intidata();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.intidata();
                this.authority();
            },
            selectpicker() {
                let that = this
                this.$refs.picker.clearInput(true)
            },
            getpicker(data) {
                let that = this
                console.log(data)
                that.dataDetail.Head.picker = data.Name
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'InvissueManufactureViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.intidata();
            },
            // 数据一览
            intidata() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                //let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                console.log(JSON.stringify(data));
                that.$http.urlpost('/Inv/UniversalOut/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.isShowEdit = true;
                that.isEdit = true;
                let parm = {
                    Code: row.Order_No,
                    List: []
                };
                this.$refs.order.clearInput(this.isShowEdit, parm);
            },
            // 新增
            add() {
                let that = this;
                if (that.oldDataDetail != JSON.stringify(that.dataDetail)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                that.editif = true;
                that.isBtnNegative = false;
                let datetime = (
                    new Date().getFullYear() +
                    '-' +
                    (new Date().getMonth() + 1) +
                    '-' +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    ':' +
                    new Date().getMinutes() +
                    ':' +
                    new Date().getSeconds()
                ).toString();
                // that.isEdit = false;
                // that.isShowEdit = true;
                let parm = {
                    Code: '',
                    List: []
                };
                that.getdlist(parm);
                //that.oldDataDetail = JSON.stringify(that.dataDetail)
                //this.$refs.order.clearInput(this.isShowEdit, parm);
                that.authority();
            },
            // 刷新
            reflash() {
                // let that = this;
                // that.intidata();//刷左边
                // //查右边
                // //刷右边
                // if(!that.$limits.fnIsEmpty(that.Head.Order_No)){
                // 	let parm = {
                // 		Code: that.Head.Order_No,
                // 		List: []
                // 	};
                // 	that.getdlist(parm);
                // }else{
                // 	//清空右边

                // }

                let that = this;
                if (that.oldDataDetail != JSON.stringify(that.dataDetail)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();//刷左边
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                                let parm = {
                                    Code: that.dataDetail.Head.Order_No,
                                    List: []
                                };
                                that.getDetail(parm);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.intidata();//刷左边
                    if (!that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)) {
                        let parm = {
                            Code: that.dataDetail.Head.Order_No,
                            List: []
                        };
                        that.getDetail(parm);
                    } else {
                        that.confirmAdd()
                    }
                }

            },
            impx() {
                let item = {
                    //label: '通用出库导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/14',
                    url: '/exp/14',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/14'});
                this.$store.commit('selectMenu', item);
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Inv/UniversalOut/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "InvissueManufactureViewInfo",
                    fromname: that.$t('getapi[976]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            selectRow(row) {
                let that = this;
                that.nowPOCode = row.Order_No;
            },
            //左侧点击
            edits(e) {
                let that = this;
                if(that.nowPOCode == e.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    if (!this.$limits.menuvisible("plv2", 282, 1)) {
                        return
                    }
                    if (that.oldDataDetail != JSON.stringify(that.dataDetail)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e
                                that.IsNew = false;
                                that.nowPOCode = e.Order_No;
                                let parm = {
                                    Code: e.Order_No,
                                    List: []
                                };
                                that.getdlist(parm);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e
                        that.IsNew = false;
                        that.nowPOCode = e.Order_No;
                        let parm = {
                            Code: e.Order_No,
                            List: []
                        };
                        that.getdlist(parm);
                    }
                }, 100);
            },
            getdlist(data) {
                let that = this;
                if (data.Code == '') {
                    //reset data 新建
                    let datetime = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
                    that.dataDetail.Head = {
                        Finance_Date: datetime,
                        keep_account_time: datetime,
                        Negative_Flag: false,
                        IsCreatingRed: false,
                        IsShowOldOrderNo: false,
                        Order_No: '',
                        Order_status: 0,
                        Order_statusString: '生成',
                        Finance_Status: -1,
                        issue_person: '',
                        Issue_Dept: '',
                        remark: '',
                        Keep_Person: '',
                        Regist_Person: '',
                        keep_account_person: that.user,
                        picker: '',
                        coll_sign:'',
                    };
                    that.dataSetMain = [];
                    that.dataSetAssist = [];
                    that.SoLists = [];                    
                    that.lineno = 0;
                    that.IsNew = true;
                    // that.isBtnAddDisable = false;
                    // that.isBtnSaveDisable = false;
                    that.editif = true;
                    that.oldDataDetail = JSON.stringify(that.dataDetail)
                    that.authority();
                } else {
                    that.getDetail(data);
                }
            },
            getDetail(data) {
                let that = this;
                that.IsShowOldOrderNo = false;
                that.dloading = true;
                that.dataSetMain = []; // 主表数据
                that.dataSetAssist = []; //次主表数据
                let parm = data;
                parm.LangType=that.$processdata.getLang()
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Inv/UniversalOut/InvIssueDetail', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSetMain = []; // 主表数据
                        that.dataSetAssist = []; //次主表数据
                        that.SoLists=[];
                        that.dataDetail.Head = res.DataContent.head[0];
                        that.dataDetail.attr = res.DataContent.attr
                        that.dataDetail.attr = res.DataContent.attr
                        if(that.dataDetail.Head.Negative_Flag){
                            that.IsShowOldOrderNo = true
                        }
                        that.SoLists=res.DataContent.SoLists;
                        let allArray = res.DataContent.line;
                        for (let i = 0; i < allArray.length; i++) {
                            if (that.lineno < allArray[i].line_No) that.lineno = allArray[i].line_No;
                            //if (allArray[i].Assist_MeasureUnit === '') {
                            if (that.$limits.fnIsEmpty(allArray[i].Assist_MeasureUnit)) {
                                that.dataSetMain.push(allArray[i]);
                            } else {
                                that.dataSetAssist.push(allArray[i]);
                            }
                        }
                        that.totalMain = that.dataSetMain.length;
                        that.totalAssist = that.dataSetAssist.length;
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.authority();
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(this.RightSelectIndex)
                        })
                    }
                    else {
                        that.confirmAdd();
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            //生成红单
            gred(Order_No) {
                let that = this;
                that.dloading = true;
                let parm = {
                    Code: Order_No,
                    List: []
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Inv/UniversalOut/InvIssueRedDetail', parm, function (res) {
                    if (res.Success == 1) {
                        that.IsShowOldOrderNo = true;
                        that.dataSetMain = []; // 主表数据
                        that.dataSetAssist = []; //次主表数据
                        that.SoLists=[];
                        that.dataDetail.Head = res.DataContent.head[0];
                        that.SoLists=res.DataContent.SoLists;
                        that.dataDetail.Head.Negative_Flag=true;
                        let allArray = res.DataContent.line;
                        for (let i = 0; i < allArray.length; i++) {
                            if (that.lineno < allArray[i].line_No) that.lineno = allArray[i].line_No;
                            if (that.$limits.fnIsEmpty(allArray[i].Assist_MeasureUnit)) {
                                that.dataSetMain.push(allArray[i]);
                            } else {
                                that.dataSetAssist.push(allArray[i]);
                            }
                        }
                        that.totalMain = that.dataSetMain.length;
                        that.totalAssist = that.dataSetAssist.length;
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.authority();
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            print() {
                //判断状态
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)) {
                    /*if (that.nowPOCode == 0) return;
                    let parm = {
                        po_no: that.nowPOCode,
                        TemplateName: '09材料出库单.xlsx'
                    };
                    that.loading = true;
                    that.$http.urlpost('/Print/MIPrint', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = res.Key;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    });*/
                    let parm = {
                        Code:'inv_issue_manufacture'
                    }
                    that.$http.urlpost('/Basic/GetPrintTemplates', parm, function (res) {
                        if (res.Success == 1) {
                            that.visDetailPrintType = true
                            that.dataPrint = res.DataContent
                        }
                    });
                }
                else{ 
                    // SO生产订单AAA新品-板材排版一览-研发领料-通用出库  
                    if(that.$limits.fnIsEmpty(that.dataDetail.Head.coll_sign)){ return; }
                        that.$refs.SetBtn.SetOneBtnEnable('print', false);
                        that.loading = true;
                        let parm = {
                            coll_sign: that.dataDetail.Head.Order_No,
                            TemplateName: '22板材发料单.xlsx',
                            notice_person:that.dataDetail.Head.Keep_Person
                        };
                        that.$http.urlpost('/Print/SCPrint', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('print', true);
                        if (res.Success == 1) {
                            let hrefurl = res.Key;
                            window.open(hrefurl);
                        } 
                        that.loading = false;
                    });
                }
                
            },
            changePrint(val,code){
                let that = this
                that.tempname = code
            },
            confirmPrint(){
                let that = this
                if(that.$limits.fnIsEmpty(that.dataDetail.Head.Order_No)){
                    return;
                }
                that.loading = true;
                let templatename = that.tempname
                let parm = {
                    po_no: that.nowPOCode,
                    TemplateName: templatename
                };
                that.loading = true;
                that.$http.urlpost('/Print/MIPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.visDetailPrintType = false;
                    that.loading = false;
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            // 排序
            sortChange(column){
                let that = this
                that.$processdata.sortChange(column,that.dataSetMain)
            },
            // 排序
            sortChangeAssis(column){
                let that = this
                that.$processdata.sortChange(column,that.dataSetAssist)
            },
            expStatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[3557]')//'关闭';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[3607]')//'审核';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            selectNewProject(type,data) {
                let that = this;
                if (!that.editif) return;
                that.rowindex = data.$index
                if (type == 1) {
                    this.$refs.newproject1.clearInput(true);
                } else {
                    this.$refs.newproject2.clearInput(true);
                }
            },
            getNewProject1(data) {
                let that = this
                console.log(data)
                that.dataSetMain[that.rowindex].new_part_code = data.part_code
                that.dataSetMain[that.rowindex].new_part_version = data.part_version
            },
            getNewProject2(data) {
                let that = this
                that.dataSetAssist[that.rowindex].new_part_code = data.part_code
                that.dataSetAssist[that.rowindex].new_part_version = data.part_version
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 282,1) < 1){
                    return false
                }
                let flag = that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
            }
        }
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
